import { render, staticRenderFns } from "./NeedEditModal.vue?vue&type=template&id=2abba428&scoped=true&"
import script from "./NeedEditModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedEditModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abba428",
  null
  
)

export default component.exports